export default __webpack_public_path__ + "static/media/Instagram.4aa94f59.svg";